export const MONTHLY_PRICE_CODE = "MONTHLY";
export const QUARTERLY_PRICE_CODE = "QUARTERLY";
export const SEMI_ANNUALY_PRICE_CODE = "SEMI_ANNUALLY";
export const YEARLY_PRICE_CODE = "YEARLY";
export const MULTI_YEARLY_PRICE_CODE_2 = "MULTI_YEARLY_2";
export const MULTI_YEARLY_PRICE_CODE_3 = "MULTI_YEARLY_3";

export const newBillingPriceConfig = [
  {
    label: "Yearly",
    interval: "year",
    intervalCount: 1,
    code: YEARLY_PRICE_CODE,
  },
  {
    label: "Quarterly",
    interval: "month",
    intervalCount: 3,
    code: QUARTERLY_PRICE_CODE,
  },
  {
    label: "Semi-Annually",
    interval: "month",
    intervalCount: 6,
    code: SEMI_ANNUALY_PRICE_CODE,
  },
  {
    label: "Multi-Yearly (2 years)",
    interval: "year",
    intervalCount: 2,
    code: MULTI_YEARLY_PRICE_CODE_2,
  },
  {
    label: "Multi-Yearly (3 years)",
    interval: "year",
    intervalCount: 3,
    code: MULTI_YEARLY_PRICE_CODE_3,
  },
  {
    label: "Monthly",
    interval: "month",
    intervalCount: 1,
    code: MONTHLY_PRICE_CODE,
  },
];

export const getPlanSelectionForTeam = (seatsItem) => {
  const interval = seatsItem?.price?.recurring?.interval;
  const intervalCount = seatsItem?.price?.recurring?.interval_count;
  let code = "";

  if (interval === "month") {
    switch (intervalCount) {
    case 1:
      code = MONTHLY_PRICE_CODE;
      break;
    case 3:
      code = QUARTERLY_PRICE_CODE;
      break;
    case 6:
      code = SEMI_ANNUALY_PRICE_CODE;
      break;
    default:
      code = MONTHLY_PRICE_CODE;
    }
  } else if (interval === "year") {
    switch (intervalCount) {
    case 1:
      code = YEARLY_PRICE_CODE;
      break;
    case 2:
      code = MULTI_YEARLY_PRICE_CODE_2;
      break;
    case 3:
      code = MULTI_YEARLY_PRICE_CODE_3;
      break;
    default:
      code = YEARLY_PRICE_CODE;
    }
  } else {
    code = YEARLY_PRICE_CODE;
  }

  return newBillingPriceConfig.find((config) => config.code === code);
};

export const leadCaptureTierOptions = [
  { label: "No Leads (DBC)", value: 0, excludedPlans: [] },
  { label: "500", value: 500, excludedPlans: [MONTHLY_PRICE_CODE] },
  { label: "1000", value: 1000, excludedPlans: [MONTHLY_PRICE_CODE] },
  { label: "2500", value: 2500, excludedPlans: [MONTHLY_PRICE_CODE] },
  { label: "5000", value: 5000, excludedPlans: [MONTHLY_PRICE_CODE] },
  { label: "10000", value: 10000, excludedPlans: [MONTHLY_PRICE_CODE] },
  { label: "25000", value: 25000, excludedPlans: [MONTHLY_PRICE_CODE] },
  { label: "50000", value: 50000, excludedPlans: [MONTHLY_PRICE_CODE] },
  { label: "50000+", value: 50001, excludedPlans: [MONTHLY_PRICE_CODE] },
];
